import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { loginComponent } from './create-workspace/login/login.component';
import { HomeComponent } from './create-workspace/home/home.component';
import { MachineListComponent } from './create-workspace/machine-list/machine-list.component';
const routes: Routes = [
  // { path: 'simulator', component: CreateWorkspaceComponent },
  // { path: 'login', component: loginComponent },
  // { path: 'delete/:id/:p', component: deleteComponent },
  // { path: 'delete', component: deleteComponent },
    { path: '', component: loginComponent},
    { path: 'home',component: HomeComponent},
    { path: 'machine-list',component: MachineListComponent}
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {

}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts